export default {
  methods: {
    getMemberRecords (search, loading) {
      loading(true)
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (search.length > 2) {
        pageUrl += 'member?all=all'
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
          pageUrl += `&agent_id=${c.id}`
        }
        pageUrl += `&name=${search}`
        this.$axios.get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
          loading(false)
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GetMemberRecordSearch.js